<script setup lang="ts">
import { JadeToastProvider, provideAuthFlow } from '@akaal/jade-ui'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'

import { createAuthFlow } from '@/auth/flow'
import { useAuthStore } from '@/stores/auth'

const { t } = useI18n()

// The library's pre-console pages are routed to directly; this is the one
// place they learn about the store, the router and the catalogue.
provideAuthFlow(createAuthFlow({ auth: useAuthStore(), router: useRouter(), t }))
</script>

<template>
  <RouterView />
  <!-- Mounted once, above every page, so a failure toast outlives the
       navigation that follows it. -->
  <JadeToastProvider />
</template>
